import { render } from "./InterviewList.vue?vue&type=template&id=1073b850"
import script from "./InterviewList.vue?vue&type=script&lang=js"
export * from "./InterviewList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\employment\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__